import { googleAnalytics } from './reactGAMiddlewares'

export const all = [
    googleAnalytics
]